import React from 'react'
import style from './style.module.css'

export default function Sign(props) {
  const { date } = props;
  return (
    <span className={style.sign}>
      {date ? "__/__/____" : ""}
    </span>
  )
}